import type { CommunityMemberListResponse, CommunityMemberListRow, PaginationMeta } from '~/interfaces/community';

import { type MemberFeedPage, useMemberPagedFeed } from './useMemberPagedFeed';

const communityMemberBlocksKeys = {
  all: ['community-member-blocks'] as const,
};

const COMMUNITY_MEMBER_BLOCKS_PATH = '/community/member_blocks';

const fetchCommunityMemberBlocksPage = async (
  cursor: string | undefined,
): Promise<MemberFeedPage<CommunityMemberListRow>> => {
  const params = new URLSearchParams();
  if (cursor) params.set('cursor', cursor);

  const query = params.toString();
  const response = await fetch(query ? `${COMMUNITY_MEMBER_BLOCKS_PATH}?${query}` : COMMUNITY_MEMBER_BLOCKS_PATH);
  if (!response.ok) throw new Error('Failed to fetch community member blocks');

  const data: CommunityMemberListResponse = await response.json();
  return { items: data.members, meta: data.meta };
};

interface UseCommunityMemberBlocksOptions {
  initialMembers?: CommunityMemberListRow[];
  initialMeta?: PaginationMeta;
}

const useCommunityMemberBlocks = ({ initialMembers, initialMeta }: UseCommunityMemberBlocksOptions = {}) => {
  const { items, ...rest } = useMemberPagedFeed<CommunityMemberListRow>({
    queryKey: communityMemberBlocksKeys.all,
    fetchPage: fetchCommunityMemberBlocksPage,
    initialItems: initialMembers,
    initialMeta,
  });

  return { members: items, ...rest };
};

export type { UseCommunityMemberBlocksOptions };
export { communityMemberBlocksKeys, useCommunityMemberBlocks };
